import { useIntl } from 'react-intl';

export const CsvImportInstructions = () => {
    const intl = useIntl();

    return (
        <section
            className='panel panel-default panel-body bg-lightest margin-bottom-15'
            aria-labelledby='csv-import-instructions-title'
            data-testid='csv-import-instructions'
        >
            <h4 id='csv-import-instructions-title' className='margin-top-0 margin-bottom-5'>
                {intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.title',
                    defaultMessage: 'Prepare your CSV',
                })}
            </h4>
            <ol className='margin-bottom-0 padding-left-20'>
                <li>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.template',
                        defaultMessage:
                            'Download the template that matches your load: Bulk for bulk material or Cargo for other freight.',
                    })}
                </li>
                <li>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.structure',
                        defaultMessage: 'Keep the first two rows and the column order unchanged.',
                    })}
                </li>
                <li>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.values',
                        defaultMessage: 'Add one order per row. Enter dates as DD.MM.YYYY and times as HH:mm.',
                    })}
                </li>
                <li>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.instructions.save-upload',
                        defaultMessage:
                            'Save the file as a semicolon-separated CSV, upload it, and review the orders before importing.',
                    })}
                </li>
            </ol>
        </section>
    );
};
